var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"height":"100%","width":"100%"},attrs:{"id":"app"}},[_c('GeneratePdfLoader',{staticStyle:{"z-index":"2000"}}),_c('ReportLoader',{staticStyle:{"z-index":"2000"}}),_c('PreLoader',{staticStyle:{"z-index":"2000"}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }